import { Material } from "../Material/Material.type";
import { Project } from "../Project/Project.type";
import { Store } from "../Store/Store.type";
import { ApiCallState } from "../Utils";

export interface Inventory extends Material {
  item_code: string;
  project_id?: number | null;
  project?: Project;
  store?: Store;
  quantity: number;
  key: number;
  unit_price: number;
}

export type StockCardType = {
  stock_card: {
    material: Material;
    date: string;
    issued: number;
    key: number;
    plate_no: string;
    received: number;
    returned: number;
    transferred: number;
    identification: string;
    pad_ref: string;
    unit_price: number;
    balance: number;
  }[];
  summery: {
    total_received: number;
    total_returned: number;
    total_transferred: number;
    total_issued: number;
    unit_price: number;
  };
};

export type InventoryStateTypes = {
  fetchAll: ApiCallState<Inventory[]>;
  fetchAllQueried: ApiCallState<Inventory[]>;
  fetchOne: ApiCallState<Inventory | {}>;
  fetchStockCard: ApiCallState<StockCardType>;
};

export const InventoryActionTypes = {
  FETCH_ALL_INVENTORY: "FETCH_ALL_INVENTORY",
  FETCH_ALL_INVENTORY_RESET: "FETCH_ALL_INVENTORY_RESET",
  FETCH_ALL_INVENTORY_FAILURE: "FETCH_ALL_INVENTORY_FAILURE",
  FETCH_ALL_INVENTORY_SUCCESS: "FETCH_ALL_INVENTORY_SUCCESS",

  FETCH_ALL_QUERIED_INVENTORY: "FETCH_ALL_QUERIED_INVENTORY",
  FETCH_ALL_QUERIED_INVENTORY_RESET: "FETCH_ALL_QUERIED_INVENTORY_RESET",
  FETCH_ALL_QUERIED_INVENTORY_FAILURE: "FETCH_ALL_QUERIED_INVENTORY_FAILURE",
  FETCH_ALL_QUERIED_INVENTORY_SUCCESS: "FETCH_ALL_QUERIED_INVENTORY_SUCCESS",

  FETCH_ONE_INVENTORY: "FETCH_ONE_INVENTORY",
  FETCH_ONE_INVENTORY_RESET: "FETCH_ONE_INVENTORY_RESET",
  FETCH_ONE_INVENTORY_FAILURE: "FETCH_ONE_INVENTORY_FAILURE",
  FETCH_ONE_INVENTORY_SUCCESS: "FETCH_ONE_INVENTORY_SUCCESS",

  FETCH_INVENTORY_STOCK_CARD: "FETCH_ANALYSIS_INVENTORY_STOCK_CARD",
  FETCH_INVENTORY_STOCK_CARD_RESET: "FETCH_ANALYSIS_INVENTORY_STOCK_CARD_RESET",
  FETCH_INVENTORY_STOCK_CARD_FAILURE: "FETCH_INVENTORY_STOCK_CARD_FAILURE",
  FETCH_INVENTORY_STOCK_CARD_SUCCESS: "FETCH_INVENTORY_STOCK_CARD_SUCCESS",
};
